import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { loadDriverOnboarding } from "../services/driverOnboardingService";
import "../components/DriverOnboarding.css";

export default function DriverVerificationReturn() {
  const navigate = useNavigate();
  const [message, setMessage] = useState("Confirmando o resultado com segurança…");

  useEffect(() => {
    let active = true;
    let attempts = 0;
    const check = async () => {
      attempts += 1;
      try {
        const { kyc } = await loadDriverOnboarding();
        if (!active) return;
        if (kyc?.status === "APPROVED") {
          navigate("/cadastro-motorista", { replace: true });
          return;
        }
        if (["DECLINED", "EXPIRED", "ABANDONED", "REQUIRES_REVERIFICATION", "REQUIRES_RESUBMISSION"].includes(kyc?.status)) {
          setMessage("A verificação precisa de uma nova tentativa. Você voltará ao cadastro.");
          setTimeout(() => navigate("/cadastro-motorista", { replace: true }), 1400);
          return;
        }
      } catch { /* webhook pode chegar alguns instantes depois do redirecionamento */ }
      if (attempts < 10) setTimeout(check, 1200);
      else {
        setMessage("A análise continua em segundo plano. Você pode acompanhar pelo cadastro.");
        setTimeout(() => navigate("/cadastro-motorista", { replace: true }), 1800);
      }
    };
    check();
    return () => { active = false; };
  }, [navigate]);

  return <div className="driver-onboarding-loading" style={{ color: "#f8fbff", textAlign: "center", padding: 28 }}>
    <div><span style={{ display: "inline-block", marginBottom: 24 }} /><h2>Verificação de identidade Zuno</h2><p style={{ color: "#9aa8c5" }}>{message}</p></div>
  </div>;
}
